export const PLATFORM_TYPE = {
    WEB: 'WEB',
    MOBILE: 'MOBILE',
} as const;

export type PlatformType = (typeof PLATFORM_TYPE)[keyof typeof PLATFORM_TYPE];

export const FEATURE_FLAGS = {
    ENABLE_COLLECTION_ACCOUNT: 'moniebook.pos.enableCollectionAccount',
    ENABLE_REGISTER_TERMINAL_CONNECT: 'moniebook.pos.registerTerminalConnect',
    ENABLE_STOCK_DIVERGENCE_MONITORING:
        'moniebook.pos.stockDivergenceMonitoring',
    ENABLE_NEW_FIRESTORE_STOCK_TRACKING:
        'moniebook.pos.firestoreStockStructureUpdate',
    ENABLE_REFUNDS: 'moniebook.pos.enableRefundsWebRegister',
    ENABLE_STOCK_TRACKING_FALLBACK: 'moniebook.pos.register_stock_api_fallback',
    ENABLE_PAYMENT_RESTRICTIONS:
        'moniebook.pos.enableRegisterPaymentRestriction',
    PREVENT_CHECKOUT_OVERPAYMENT: 'moniebook.pos.prevent_checkout_overpayment',
    ENABLE_ITEM_LEVEL_TAXES: 'moniebook.pos.enableItemLevelTaxes',
    FILTER_PAYMENT_METHODS_BY_BRANCH:
        'moniebook.pos.globusPaymentMethodsByBranch',
    ENABLE_CHANGE_TRACKER_THROTTLE: 'moniebook.pos.enableChangeTrackerThrottle',
    ENABLE_EXTENDED_NOTE_LIMIT: 'moniebook.pos.enableExtendedNoteLimit',
    ENABLE_NEW_CART_ARCHITECTURE: 'moniebook.pos.enableNewCartArchitecture',
    ENABLE_NEW_DISCOUNT: 'moniebook.pos.enableDiscountStacking',
    ENABLE_SIX_DIGIT_PIN: 'moniebook.pos.sixDigitRegisterPin',
    ENABLE_PRINT_REPORTS: 'moniebook.pos.enablePrintReportFeature',
    ENABLE_PROGRESSIVE_INVENTORY_SYNC:
        'moniebook.pos.enableProgressiveInventorySync',
    ENABLE_MULTI_UNIT_SELECTOR: 'moniebook.pos.enableMultiUnitSelector',
    ENABLE_PRINT_AGENT_INTEGRATION: 'moniebook.pos.enablePrintAgentIntegration',
    ENABLE_DOCKETS: 'moniebook.pos.enableWebRegisterDockets',
    ENABLE_BULK_COLLECT_PAYMENT: 'moniebook.pos.enableBulkCollectPayment',
    ADVANCED_RECEIPT_CUSTOMIZATION:
        'moniebook.pos.enableAdvancedReceiptCustomization',
    AUTO_PICK_PRICING_GROUP:
        'moniebook.pos.enablePricingGroupAutoApplyPriceTier',
    ENABLE_LOYALTY_POINTS: 'moniebook.pos.loyaltyEnabled',
    ENABLE_ITEM_LEVEL_TAX_REPORTING:
        'moniebook.pos.enableItemLevelTaxesReporting',
    ENABLE_KEYPAD_WIGGLE: 'moniebook.pos.enableKeypadWiggle',
    ENABLE_MODIFIERS: 'moniebook.pos.enableModifiers',
    ENABLE_PAYMENT_FLOW_V2: 'moniebook.pos.enablePaymentFlowV2',
    ENABLE_NEW_SEARCH: 'moniebook.pos.enableNewSearch',
} as const;

export type FeatureFlag = (typeof FEATURE_FLAGS)[keyof typeof FEATURE_FLAGS];
